<template>
  <div class="message-template-email-content">
    <b-card>
      <b-row class="email-header-container">
        <b-col class="email-header-content">
          <b-col class="email-sender-info" cols="10">
            <b-img
              v-if="$store.getters.profile.organization.logo"
              :src="$store.getters.profile.organization.logo"
              class="logo"
            />
            <div v-else>
              <div class="logo">
                {{ orgAbbreviation }}
              </div>
            </div>
            <div class="sender-info">
              <label>{{ $store.getters.profile.organization.name }}</label>
              <p>{{ messageTemplate.name }}</p>
              <p class="to-label">
                To: <span>{{ customerName }}</span>
              </p>
            </div>
          </b-col>
          <b-col cols="2" sm="3">
            <p class="time">
              {{ localTime }}
            </p>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row class="email-body">
            <b-col>
              <p>
                {{ renderedBody }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script lang="ts">
import endpoints from '@/utils/endpoints'
import moment from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'

interface MessageTemplate {
  sms_body: string
}

@Component
export default class MessageTemplateEmail extends Vue {
  @Prop({ type: Object }) readonly messageTemplate!: MessageTemplate
  renderedBody = 'Please save this template to view preview'

  mounted() {
    if (this.$route.params.messageTemplateID) {
      this.renderTemplate()
    }
  }

  async renderTemplate() {
    const response = await this.axios.post(
      endpoints.randomRenderMessageTemplate(
        this.$route.params.merchantID,
        this.$route.params.messageTemplateID
      ),
      { message_template_body: this.smsBody, type: 'EMAIL' }
    )
    this.renderedBody = response.data.rendered_body
  }

  get orgAbbreviation() {
    return this.$store.getters.profile.organization.name.charAt(0)
  }

  get localTime() {
    return moment().format('LT')
  }

  get customerName() {
    if (this.$store.getters.profile?.first_name) {
      return this.$store.getters.profile.first_name
    } else {
      return 'Customer'
    }
  }

  get smsBody() {
    return this.messageTemplate.sms_body
      ? this.messageTemplate.sms_body
      : 'New Template content goes here!'
  }
}
</script>

<style lang="scss" scoped>
.message-template-email-content {
  max-width: 60vw;
  margin-bottom: 2rem;

  div.card {
    max-height: 330px;
    padding: 0 49px 43px 46px;

    color: $darkest-gray;

    border: 1px solid $lighter-gray;
    border-radius: 18px;
    box-shadow: 0 3px 6px $container-shadow;
    opacity: 1;

    p {
      margin: 0;

      font-size: 14px;
      line-height: 19px;
      letter-spacing: -0.06px;

      span {
        padding-left: 5px;

        opacity: 0.61;
      }
    }

    div.card-body {
      padding-top: 14px;
      overflow: scroll;
    }

    .email-header-container {
      height: 84.5px;

      border-bottom: 1px solid $lighter-gray;

      .email-header-content {
        display: flex;
        padding: 0;

        .email-sender-info {
          display: flex;
        }

        .logo {
          display: block;
          width: 40px;
          height: 40px;
          margin: 5px 18px 0 7px;
          padding-left: 2px;

          color: white;
          font-size: 28px;
          text-align: center;

          background-color: $bright-blue;
          border-radius: 50%;
        }

        .sender-info {
          display: flex;
          flex-direction: column;

          p {
            width: 400px;
            overflow: hidden;

            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        label {
          margin-bottom: 2px;

          font-weight: bold;
          font-size: 20px;
          line-height: 26px;
          letter-spacing: -0.08px;

          opacity: 1;
        }
      }

      div.col {
        height: 84.5px;
      }

      .to-label {
        margin-top: 2px;
      }

      .time {
        text-align: left;

        opacity: 0.63;
      }
    }

    .email-body {
      min-height: 112px;
      max-height: 280px;
      margin-top: 16.5px;

      white-space: pre-wrap;
    }
  }
}
</style>
